<template>
  <div>
    <div class="page-title">{{siteName}} Supports the Sponsor Community</div>
    <section>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.</p>
    </section>

    <title-block title="Request Sponsorship"  color-theme="primary-color">
      <div class="input-group half left">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.firstname}" label="Firstname:">
          <b-form-input placeholder="Enter First Name" type="text" v-model="requestData.firstname"/>
        </b-form-fieldset>
      </div>
      <div class="input-group half">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.lastname}" label="Lastname:">
          <b-form-input placeholder="Enter Last Name" type="text" v-model="requestData.lastname"/>
        </b-form-fieldset>
      </div>
      <div class="devider"></div>
      <div class="input-group">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.title}" label="Title:">
          <b-form-input placeholder="Enter Your Title" type="text" v-model="requestData.title"/>
        </b-form-fieldset>
      </div>
      <div class="devider"></div>
      <div class="input-group">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.organization}" label="Organization:">
          <b-form-input placeholder="Enter Organization" type="text" v-model="requestData.organization"/>
        </b-form-fieldset>
      </div>
      <div class="devider"></div>
      <div class="input-group half left">
        <b-form-fieldset label="Email Address:" :class="{error: attemptSubmit && !validation.email}">
          <b-form-input placeholder="Enter Email Address" type="text" v-model="requestData.email"/>
        </b-form-fieldset>
      </div>
      <div class="input-group half">
        <b-form-fieldset label="Phone:" :class="{error: attemptSubmit && !validation.phone}">
          <b-form-input v-model="requestData.phone" placeholder="Enter Phone Number" :formatter="phoneFormater"/>
        </b-form-fieldset>
      </div>
      <div class="devider"></div>
      <div class="input-group half left">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.topic}" label="Conference Topic:">
          <b-form-input placeholder="Describe your conference topic" type="text" v-model="requestData.topic"/>
        </b-form-fieldset>
      </div>
      <div class="input-group half">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.date}" label="Conference Date:">
          <b-form-input placeholder="Enter the date" type="text" v-model="requestData.date" :formatter="dateFormater"/>
        </b-form-fieldset>
      </div>
      <div class="devider"></div>
      <div class="input-group">
        <b-form-fieldset :class="{error: attemptSubmit && !validation.description}" :label="`Please describe your event and how ${siteName} could fit into it:`">
          <b-form-input textarea :rows=3 v-model="requestData.description"></b-form-input>
        </b-form-fieldset>
      </div>
      <div class="input-group">
        <button v-on:click="request()">Submit</button>
        <div v-if="attemptSubmit && !isValid">Error</div>
      </div>
    </title-block>
  </div>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import FormatersMixin from '@/components/shared/mixins/FormatersMixin'
  export default {
    name: 'sponsorship-reqeuest',
    components: {
      TitleBlock
    },
    mixins: [FormatersMixin],
    methods: {
      request () {
        console.log(this.isValid)
        if (this.isValid) {
          console.log(JSON.parse(JSON.stringify(this.requestData)), this.isValid)
          this.attemptSubmit = false
          Object.keys(this.requestData).every(function (key) {
            this.requestData[key] = ''
            return true
          }, this)
        } else {
        }
      }
    },
    computed: {
      validation: function () {
        var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return {
          firstname: !!this.requestData.firstname.trim(),
          lastname: !!this.requestData.lastname.trim(),
          title: !!this.requestData.title.trim(),
          organization: !!this.requestData.organization.trim(),
          email: emailRE.test(this.requestData.email),
          phone: /^\(\d\d\d\)\s\d\d\d-\d\d\d\d$/.test(this.requestData.phone),
          topic: !!this.requestData.topic.trim(),
          date: /^\d\d\/[01]\d\/[0123]\d\/\d\d\d\d$/.test(this.requestData.date),
          description: !!this.requestData.description.trim()
        }
      },
      isValid: function () {
        var validation = this.validation
        this.attemptSubmit = true
        return Object.keys(validation).every(function (key) {
          return validation[key]
        })
      }
    },
    data () {
      return {
        siteName: process.env.SITE_NAME,
        attemptSubmit: false,
        requestData: {
          firstname: '',
          lastname: '',
          title: '',
          organization: '',
          email: '',
          phone: '',
          topic: '',
          date: '',
          description: ''
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  .error {
    color: red;
  }

  .half{
    width: 48%;
    float: left;
    position: relative;
  }

  .half.left{
    margin-right: 4%;
  }

  label {
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    width: 100%;
    display: block;
  }

  input, button, textarea {
    border-radius: 4px;
    border: 1px solid #999;
  }

  input::-webkit-input-placeholder {color: #aaa;}
  input::-moz-placeholder          {color: #aaa;}/* Firefox 19+ */
  input:-moz-placeholder           {color: #aaa;}/* Firefox 18- */
  input:-ms-input-placeholder      {color: #aaa;}

  .input-group {
    display: inline-block;
    margin-top: 20px;
    input, textarea{
      width: 100%;
    }
  }

  .devider {
    border-bottom: 1px solid $devider;
    height: 20px;
    width: 100%;
    display: flex;
   }

  button, input{
    height: 32px;
    padding: 6px;
  }

  button {
    font-size: 14px;
    padding: 6px 20px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// SponsorshipRequestPage.vue?3934ed8e